<template>
  <div>
    <div class="dasharea">
      <router-view></router-view>
    </div>
    <Navbar
      v-if="navbarBottom"
      v-bind:showBrand="false"
      v-bind:navbarBottom="true"
      v-bind:showLogout="false"
      v-bind:items="sidebarItems"
      v-bind:hostNavbar="true"
      v-bind:replaceInsteadOfPush="true"
    />
  </div>
</template>

<script>
import Navbar from "../components/Navbar";

export default {
  name: "HostDashboard",
  components: {
    Navbar
  },
  computed: {
    navbarBottom() {
      return !this.$route.path.startsWith("/host/go");
    }
  },
  data() {
    return {
      sidebarItems: [
        { id: 1, item: { name: "Hosting", to: "/host" } },
        { id: 2, item: { name: "New Quiz", to: "/host/new" } },
        { id: 3, item: { name: "History", to: "/host/history" } }
      ]
    };
  },
  created() {
    // todo: watch store variable, check if host, redirect, profit
    this.$store.dispatch("presetStore/loadPresets", this);
  }
};
</script>

<style scoped>
.container-fluid {
  padding-top: 0px;
  padding-bottom: 50px;
}
</style>
